import Service from "../../AuthService";
const PaymentSalary = {
    getPaymentSalary(page,employee_id) {
        return Service.get("/payment_salary?page="+page+
            "&employee_id="+employee_id);
    },
    showPaymentSalary(id) {
        return Service.get("/payment_salary/" + id);
    },
    updatePaymentSalary(id, data) {
        return Service.put("/payment_salary/" + id, data);
    },
    createPaymentSalary(data) {
        return Service.post("/payment_salary", data);
    },
    deletePaymentSalary(id) {
        return Service.delete("/payment_salary/" + id);
    },
    generatePaymentSalary(data){
        return Service.get(`/generate_payment_salary/${data.week}/${data.user_id}?date=${data.date}&employee_id=${data.employee_id}&department_id=${data.department_id}&index=${data.index}`)
    },
    generatePaymentSalaryMonth(user_id){
        return Service.get("/generate_payment_salary_month/" + user_id);
    },
    closePayment(data){
        return Service.get(`/payment_close_date?date=${data.date}&week=${data.week}`);
    }

};
export default PaymentSalary;
